import YoursLeadInventoryPage from "./yours_page";
import {
  Link,
  Outlet,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import PageHeader from "../../components/pageHeader.jsx";
import LeadFormModal from "./LeadFormModal";
import { useState, useEffect } from "react";

export default function YoursPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [showModal, setShowModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    const storedRole = localStorage.getItem("role");
    if (storedUserId && storedRole) {
      setUserId(storedUserId);
      setRole(storedRole);
    } else {
      navigate("/login");
    }
  }, []);

  return (
    <>
      <div className="min-h-screen flex flex-col item-start p-4">
        <div>
          <div className="flex flex-row items-center px-4 py-2">
            <div className="flex flex-1">
              <Link
                to="yours"
                className={`font-bold px-4 pb-2 ${
                  location.pathname === "/lead_inventory/yours"
                    ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                Yours
              </Link>
              <Link
                to="all"
                className={`font-bold px-4 pb-2 ${
                  location.pathname === "/lead_inventory/all"
                    ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                All
              </Link>
              <Link
                to="shark_tank"
                className={`font-bold px-4 pb-2 ${
                  location.pathname === "/lead_inventory/shark_tank"
                    ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                    : "text-gray-400 font-bold"
                }`}
              >
                Shark Tank
              </Link>
            </div>
          </div>
          <Outlet />
          <LeadFormModal
            isOpen={showModal}
            onClose={() => setShowModal(false)}
          />
        </div>
      </div>
    </>
  );
}
